export default {
  data() {
    return {
      // eslint-disable-next-line
      engineeringDiscipline: [
        "Biomedical",
        "Business",
        "Chemical",
        "Civil",
        "Comms",
        "Control",
        "Electrical",
        "Environment",
        "Finance",
        "General",
        "Inspections",
        "Instrumentation",
        "IT",
        "Machine",
        "Mechanical",
        "Medical",
        "Multi",
        "Process",
        "Rotating",
        "Safety",
        "System",
        "Undefined"
      ],
      designBackupOptions: [
        "1oo1",
        "1oo2",
        "1oo3",
        "2oo2",
        "2oo3",
        "2oo4",
        "3oo3",
        "3oo4",
        "4oo4"
      ],
      // eslint-disable-next-line
      cert: [
        "API",
        "CE",
        "Ex",
        "LNG",
        "Quality",
        "RV",
        "SIF",
        "Temp. Class"
      ],
      // eslint-disable-next-line
      reportType: [
        "Breakdown",
        "Campaign",
        "Factory",
        "Maint",
        "Major",
        "Plan",
        "Project",
        "Retro"
      ],
      // eslint-disable-next-line
      techReportTheme: [
        "ENG",
        "MAINT",
        "OPS",
        "PROJ",
        "RAND"
      ],
      // eslint-disable-next-line
      techReportType: [
        "CI",
        "DI",
        "EFT",
        "EPT",
        "FAT",
        "ITR",
        "LAB",
        "MFT",
        "MPF",
        "OFT",
        "OPT",
        "OM",
        "SAT",
        "VIT",
        "VI"
      ],
      // eslint-disable-next-line
      techReportLife: [
        "BK",
        "PM",
        "MM",
        "NEW",
        "REF",
        "REP",
        "STD",
      ],
      // eslint-disable-next-line
      complexityOptions: [
        "High",
        "Medium",
        "Low"
      ]
    };
  }
};
